function fen2Yuan(num) {
  if (isNaN(num)) return ""
  num = Number(num)
  return (num / 100).toFixed(2)
}

function getNumber(nums) {
  const num = fen2Yuan(nums)
  const str = num.toString()
  const res = str.split(".")
  return res[0]
}

function getSmallNumber(nums) {
  const num = fen2Yuan(nums)
  const str = num.toString()
  const res = str.split(".")
  return res.length === 2 ? res[1] : ""
}

// 处理赠品数据
function flattenSlaveContent(slaveContent) {
  if (slaveContent) {
    slaveContent.list = []
    slaveContent.flattenList = []
    if (slaveContent.promotionWareItemGroups && slaveContent.promotionWareItemGroups.length) {
      slaveContent.promotionWareItemGroups.forEach(v => {
        if (v.wareItems && v.wareItems.length) {
          slaveContent.flattenList = slaveContent.flattenList.concat(v.wareItems)
          if (slaveContent.showGroup) {
            slaveContent.list.push(v.wareItems)
          } else {
            slaveContent.list = slaveContent.list.concat(v.wareItems)
          }
        }
      })
    }
  }
}
// 将选择的赠品拍平
export function flattenSelectItem(selectedItemInfo) {
  if (selectedItemInfo) {
    selectedItemInfo.list = []
    selectedItemInfo.emptyList = []
    selectedItemInfo.flattenList = []
    if (selectedItemInfo.selectedItemGroup && selectedItemInfo.selectedItemGroup.length) {
      selectedItemInfo.selectedItemGroup.forEach(v => {
        if (v.wareItems && v.wareItems.length) {
          selectedItemInfo.flattenList = selectedItemInfo.flattenList.concat(v.wareItems)
          if (selectedItemInfo.showGroup) {
            selectedItemInfo.list.push(v.wareItems)
            selectedItemInfo.emptyList.push(
              new Array(v.wareItems.length).fill({
                emptyData: true,
                canAddToCart: false,
                showAddToCart: false
              })
            )
          } else {
            selectedItemInfo.list = selectedItemInfo.list.concat(v.wareItems)
            v.wareItems.forEach(_v => {
              selectedItemInfo.emptyList.push({
                emptyData: true,
                canAddToCart: false,
                showAddToCart: false
              })
            })
          }
        }
      })
    }
  }
}

// 处理显示的价格
function addShowPrice(price) {
  if (!price) return {}
  return {
    ...price,
    isShowUnderline: price.totalOriginalPrice != price.totalPrice,
    showBigPrice: getNumber(price.totalPrice),
    showSmallPrice: getSmallNumber(price.totalPrice),
    showUnderlinePrice: fen2Yuan(price.totalOriginalPrice),
    showSavedPrice: fen2Yuan(price.savedAmount)
  }
}

// 判断出促销类型
export function getProType(data) {
  let type = "freebie-amount"
  if (data.promoType == 1) {
    type = "best-offer"
  }
  // else if (data.promoType == 2 && data.dialogInfo && !data.dialogInfo.showDialog) {
  //   // 门槛内优惠
  //   type = 'redeem-inside'
  // }
  else if (data.promoType == 2 && data.dialogInfo && data.dialogInfo.dialogType == 1) {
    // 满件赠品
    type = "freebie-offer"
  } else if (data.promoType == 3 && data.dialogInfo && data.dialogInfo.dialogType == 1) {
    // 满额赠品
    type = "freebie-amount"
  } else if (data.promoType == 2 && data.dialogInfo && data.dialogInfo.dialogType == 2) {
    // 满件换购
    type = "outside-offer"
  } else if (data.promoType == 3 && data.dialogInfo && data.dialogInfo.dialogType == 2) {
    // 满额换购
    type = "outside-amount"
  } else if (data.promoType == 2) {
    type = "freebie-offer"
  } else if (data.promoType == 3) {
    type = "freebie-amount"
  }
  console.log("typeis:", type)
  return type
}

// best offer
export function formatBestOffer(data) {
  let tagsContent = {}
  let wareItemContent = {}
  let price = {}

  if (data) {
    tagsContent = {
      slogan: data.slogan,
      list: data.promotionTags
    }
    wareItemContent = data.promotionWareItemContent || {}
    price = addShowPrice(data.price)
  }

  return {
    tagsContent,
    wareItemContent,
    price
  }
}

// 满件
export function formatOffer(data) {
  let autoGift = false // 自动赠品
  let proNum = 0 // 门槛
  let repeatTimes = 0 // 最大可享受次数
  let wareContent = {} // 主品信息
  let slaveContent = {} // 从品信息
  let ladderPro = false // 是否是阶梯，不是阶梯就是翻倍
  let dialogInfo = {} // 弹出框信息
  let price = {}

  if (data) {
    ladderPro = data.ladderPro
    autoGift = false
    repeatTimes = data.repeatTimes
    if (data.dialogInfo) {
      proNum = data.dialogInfo.proNum
      dialogInfo = data.dialogInfo
    }
    wareContent = data.promotionWareItemContent || {}
    slaveContent = data.promotionSlaveItemContent || {}
    price = addShowPrice(data.price)

    if (wareContent) {
      wareContent.list = []
      if (wareContent.promotionWareItemGroups && wareContent.promotionWareItemGroups.length) {
        wareContent.promotionWareItemGroups.forEach(v => {
          if (v.wareItems && v.wareItems.length) {
            if (ladderPro) {
              wareContent.list = wareContent.list.concat(v.wareItems)
            } else {
              wareContent.list.push(v.wareItems)
            }
          }
        })
      }
    }
    // 将赠品拍平
    flattenSlaveContent(slaveContent)
    flattenSelectItem(dialogInfo.selectedItemInfo)
  }

  return {
    autoGift,
    proNum,
    wareContent,
    slaveContent,
    ladderPro,
    dialogInfo,
    repeatTimes,
    price
  }
}

// 满额
export function formatAmount(data) {
  let autoGift = false // 自动赠品
  let wareContent = {} // 主品信息
  let slaveContent = {} // 从品信息
  let ladderPro = false // 是否是阶梯，不是阶梯就是翻倍
  let dialogInfo = {} // 弹出框信息
  let price = {}
  let repeatTimes = 0 // 最大可享受次数

  if (data) {
    ladderPro = data.ladderPro
    autoGift = data.autoGift
    repeatTimes = data.repeatTimes
    if (data.dialogInfo) {
      dialogInfo = data.dialogInfo
    }
    wareContent = data.promotionWareItemContent || {}
    if (wareContent.percentage) {
      wareContent.percentage = wareContent.percentage * 100
    }
    slaveContent = data.promotionSlaveItemContent || {}
    price = addShowPrice(data.price)
    // 将赠品拍平
    flattenSlaveContent(slaveContent)
    flattenSelectItem(dialogInfo.selectedItemInfo)
  }

  return {
    wareContent,
    slaveContent,
    autoGift,
    ladderPro,
    dialogInfo,
    price,
    repeatTimes
  }
}

// 门槛内优惠
export function formatRedeemInside(data) {
  let wareContent = {} // 主品信息
  let slaveContent = {} // 从品信息
  let ladderPro = false // 是否是阶梯，不是阶梯就是翻倍
  let proNum = 0 // 门槛
  let price = {}

  if (data) {
    ladderPro = data.ladderPro
    wareContent = data.promotionWareItemContent || {}
    slaveContent = data.promotionSlaveItemContent || {}
    price = addShowPrice(data.price)

    if (data.dialogInfo) {
      proNum = data.dialogInfo.proNum
    }

    if (wareContent) {
      wareContent.list = []
      if (wareContent.promotionWareItemGroups && wareContent.promotionWareItemGroups.length) {
        wareContent.promotionWareItemGroups.forEach(v => {
          if (v.wareItems && v.wareItems.length) {
            if (ladderPro) {
              wareContent.list = wareContent.list.concat(v.wareItems)
            } else {
              wareContent.list.push(v.wareItems)
            }
          }
        })
      }
    }

    flattenSlaveContent(slaveContent)
  }

  return {
    wareContent,
    ladderPro,
    slaveContent,
    price,
    proNum
  }
}
